import { Card, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';

export const FilterLabel = styled(Typography)({
  display: "flex",
  justifyContent: "center",
  backgroundColor: "secondary.main",
  color: "secondary.contrastText"
});

export const FilterCard = styled(Card)(({ theme }) => ({
  minWidth: "150px",
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  width: "auto",
  marginTop: "5px",
  marginBottom: "5px"
}));